module.exports = __webpack_public_path__ + "img/active-layer9.94f1db17.png";